<template>
  <div class="web-content">
    <swiper :type="6"></swiper>
    <idea></idea>
    <offer></offer>
  </div>
</template>

<script>
import swiper from "./swiper";
import idea from "./talent/idea";
import offer from "./talent/offer";

export default {
  components: {
    swiper,
    idea,
    offer
  }
};
</script>

